var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.auth.userInfo.responseCode === '00' && this.$route.path !== '/api-documentation' && this.$route.path !== '/create-new-campaign' && this.$route.path !== '/create-new-campaign-success')?_c('dashboard-header'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }